import Vue from 'vue'
import { LocaleProvider, Pagination, message, Spin, Breadcrumb, Tabs } from 'ant-design-vue'
import './index.less'

Vue.use(LocaleProvider)
Vue.use(Pagination)
Vue.use(Spin)
Vue.use(Breadcrumb)
Vue.use(Tabs)
Vue.prototype.$message = message
